import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"

type Props = {
  fill?: string;
} | SvgProps;

const PrivacyPolicyIcon = ({ fill, ...rest }: Props) => (

  <Svg
    viewBox="0 0 116.42 122.88"
    width={26.53}
    height={28}
    {...rest}
  >
    <Path
      fill={fill ?? "#1C1C1E"}
      d="M88 61c11 6 20 10 28 9 2 29-9 46-28 53-18-7-29-23-28-54a40 40 0 0 0 28-8ZM63 12l21 20H63V12ZM21 56h42c3 0 3 4 1 5H21c-3 0-3-5 0-5Zm0 17h29l1 5H21c-3 0-3-5 0-5Zm0 16h31l2 6H21c-3 0-3-6 0-6Zm0-50h24c4 0 4 6 0 6H21c-3 0-3-6 0-6Zm0-15h14c3 0 3 5 0 5H21c-3 0-3-5 0-5Zm74 10a3 3 0 0 0-2-3L62 1a3 3 0 0 0-3-1H6a6 6 0 0 0-6 6v106a6 6 0 0 0 6 7h60a52 52 0 0 1-5-7H7V7h49v28a3 3 0 0 0 3 3h29v12l7 4V34Zm-7 37c7 4 14 6 20 6 1 20-7 31-20 36V71Zm0-7c9 6 18 9 25 8 1 26-8 41-25 47-16-6-26-20-25-47a36 36 0 0 0 25-8Z" />
  </Svg>
)

export default PrivacyPolicyIcon